/**
 * K5: the seam ride (packages/shared systems/seamGate.ts). While the ride runs, a dark fade with a scrolling road
 * strip (placeholder) covers the view and a lore card in the loading screen's `.ls-card` frame shows the region
 * bound for (Thai name) and one line of the legend (data/lore.ts). Reads `world.seam.ride`; sends nothing.
 */
import { LEGEND, type World } from '@nine/shared';
import { h } from './dom';

const LINES: readonly string[] = LEGEND.flatMap((c) => c.text);

export class SeamRideUi {
  private readonly root: HTMLElement;
  private readonly dest: HTMLElement;
  private readonly line: HTMLElement;
  private readonly road: HTMLElement;
  private key = '';

  constructor(private readonly world: World) {
    this.dest = h('div', { class: 'ls-dest' });
    this.line = h('p', { class: 'ls-tip' });
    this.road = h('div');
    Object.assign(this.road.style, {
      position: 'absolute', left: '0', right: '0', top: '50%', height: '6px',
      background: 'repeating-linear-gradient(90deg,#d8cdb4 0 28px,transparent 28px 56px)', opacity: '0.5',
    });
    const card = h('div', { class: 'ls-card' }, this.dest, this.line);
    Object.assign(card.style, { right: 'auto', left: '50%', bottom: '50%', transform: 'translate(-50%,50%)', color: '#1c1a17' });
    this.root = h('div', { hidden: true }, this.road, card);
    Object.assign(this.root.style, { position: 'fixed', inset: '0', zIndex: '55', background: '#14110d', transition: 'opacity .3s', pointerEvents: 'all' });
    document.body.appendChild(this.root);
  }

  sync(): void {
    const r = this.world.seam.ride;
    this.root.hidden = !r;
    if (!r) {
      this.key = '';
      return;
    }
    const k = `${r.gate}:${r.from}`;
    if (k !== this.key) {
      this.key = k;
      this.dest.textContent = `กำลังเดินทางไป${r.toName}`;
      this.line.textContent = LINES[(r.gate.length * 7 + r.toName.length) % LINES.length] ?? '';
    }
    const p = Math.min(1, r.t / r.dur);
    this.root.style.opacity = String(Math.min(1, p * 8, (1 - p) * 8));
    this.road.style.backgroundPositionX = `${-r.t * 240}px`;
  }
}
